// extracted by mini-css-extract-plugin
export default {"reviewStatusSelect":"RenewalResultsTab_reviewStatusSelect__4BEbZ"};